// -----------------------------------------------------------
//  OptionSorter
// -----------------------------------------------------------
const OptionSorter = (function () {
  function OptionSorter(options) {
    this.options = options;
  }

  OptionSorter.prototype.sort = function () {
    return this.options.sort(this.sortFuncFactory());
  };

  OptionSorter.prototype.sortFuncFactory = function () {
    if (this.needPredefinedSort()) {
      return this.predefinedSort;
    }
    if (this.needNumericSort()) {
      return this.numericSort;
    }
    return this.titleSort;
  };

  OptionSorter.prototype.needPredefinedSort = function () {
    for (let i = 0; i < this.options.length; i++) {
      if (this.options[i].sort_order) {
        return true;
      }
    }
    return false;
  };

  OptionSorter.prototype.needNumericSort = function () {
    for (let i = 0; i < this.options.length; i++) {
      if (!this.options[i].title.match(/^[0-9]/)) {
        return false;
      }
    }
    return true;
  };

  OptionSorter.prototype.predefinedSort = function (a, b) {
    return a.sort_order - b.sort_order;
  };

  OptionSorter.prototype.numericSort = function (a, b) {
    return parseInt(a.title) - parseInt(b.title);
  };

  OptionSorter.prototype.titleSort = function (a, b) {
    if (a.title < b.title) return -1;
    if (a.title > b.title) return 1;
    return 0;
  };

  return OptionSorter;
}());

export default OptionSorter;
